var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBallOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 35.7114C28.6773 35.7114 35.7114 28.6773 35.7114 20C35.7114 11.3228 28.6773 4.28857 20 4.28857C11.3228 4.28857 4.28857 11.3228 4.28857 20C4.28857 28.6773 11.3228 35.7114 20 35.7114Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4.28857V35.7114",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15601 30.3212C9.92712 29.2429 11.3911 27.7271 12.407 25.9196C13.423 24.112 13.9568 22.0735 13.9571 19.9999C13.9568 17.9264 13.423 15.8879 12.407 14.0803C11.3911 12.2727 9.92712 10.757 8.15601 9.67874",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.844 9.67874C30.0735 10.7574 28.6102 12.2733 27.595 14.0809C26.5795 15.8884 26.0461 17.9267 26.0461 19.9999C26.0461 22.0731 26.5795 24.1115 27.595 25.919C28.6102 27.7266 30.0735 29.2424 31.844 30.3212",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBallOutline);
export default __webpack_public_path__ + "static/media/icon_ball_outline.2b7fb320fafc5d293e3052d6dfd0f952.svg";
export { ForwardRef as ReactComponent };